import { useRef } from 'react'

import type { ScrollPositionValues } from './types'

export type ScrollMetrics = Omit<ScrollPositionValues, 'top' | 'left'>

export const toPositionValues = (metrics: ScrollMetrics): ScrollPositionValues => ({
    top: metrics.scrollTop / (metrics.scrollHeight - metrics.clientHeight) || 0,
    left: metrics.scrollLeft / (metrics.scrollWidth - metrics.clientWidth) || 0,
    clientWidth: metrics.clientWidth,
    clientHeight: metrics.clientHeight,
    scrollWidth: metrics.scrollWidth,
    scrollHeight: metrics.scrollHeight,
    scrollLeft: metrics.scrollLeft,
    scrollTop: metrics.scrollTop,
})

const isAtEnd = (metrics: ScrollMetrics) =>
    metrics.scrollHeight - metrics.clientHeight - metrics.scrollTop <= 1

export const useScrollTracking = (
    onScroll?: (position: ScrollPositionValues) => void,
    onEnd?: () => void,
) => {
    const wasAtEndRef = useRef(false)

    return (metrics: ScrollMetrics) => {
        if (onEnd) {
            const atEnd = isAtEnd(metrics)
            if (atEnd && !wasAtEndRef.current) {
                onEnd()
            }
            wasAtEndRef.current = atEnd
        }
        onScroll?.(toPositionValues(metrics))
    }
}
